<template>
  <v-autocomplete
    v-model="inputValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :rules="rules"
    :clearable="clearable"
    :label="label"
    return-object
    hide-details
    hide-selected
    :disabled="readonly"
    browser-autocomplete="nope"
    :outline="outline !== undefined ? outline : true"
    no-filter
    no-data-text="Данные не выбраны"
    :height="heightField !== undefined ? heightField : 44"
    clear-icon="close"
    :class="{ 'red lighten-4': inputValue && inputValue.isRemoved }"
    class="append-add-icon"
    prepend-inner-icon="folder_open"
    @click:clear="clear"
    @blur="handleItemChange"
    @change="$emit('change', inputValue)"
  />
</template>
<script>
import RestrictInputValue from "../../../mixins/restricted-text-input.js";
import { getReferencies } from "../../../backend/goodsDetailsApi.js";
export default {
  mixins: [RestrictInputValue],
  props: [
    "value",
    "label",
    "rules",
    "resource",
    "parentId",
    "parentFilter",
    "dataRestored",
    "disabled",
    "disableAdd",
    "parentLoading",
    "withoutParentLock",
    "withoutClearable",
    "componentName",
    "filterName",
    "filterValue",
    "outline",
    "heightField",
    "outerRegExp",
    "withInitialValue",
  ],
  data() {
    return {
      search: null,
      newItem: null,
      items: [],
      loading: false,
      inputValue: null,
    };
  },
  computed: {
    readonly() {
      if (this.withoutParentLock) {
        return this.disabled || this.parentLoading;
      }
      return (
        this.disabled ||
        (this.parentFilter && !this.parentIdValue) ||
        this.parentLoading
      );
    },
    watchOnParent() {
      return this.dataRestored;
    },
    parentIdValue() {
      return this.parentId ? this.parentId : null;
    },
    clearable() {
      return !this.withoutClearable;
    },
    isMenuActive() {
      return this.$children[0].$data.isMenuActive;
    },
  },
  watch: {
    value: {
      handler() {
        if (!this.value) {
          this.inputValue = null;
          this.search = null;
          this.items = [];
          return;
        }
        if (this.inputValue && this.value.id === this.inputValue.value) {
          return;
        }
        const selectedItem = this.items.find(i => i.value === this.value.id);
        if (selectedItem) {
          this.inputValue = selectedItem;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
    search() {
      if (!this.search && this.isMenuActive) {
        this.inputValue = null;
        this.fetchAll();
        return;
      }

      if (this.loading) {
        return;
      }

      if (this.inputValue && this.inputValue.text === this.search) {
        return;
      }

      this.loading = true;
      setTimeout(async() => {
        if (!this.search) {
          this.inputValue = null;
          this.items = [];
          this.loading = false;
          return;
        }

        let queryParams = `searchTerm=${this.search.trim()}`;
        if (this.parentFilter) {
          queryParams += `&${this.parentFilter}=${this.parentIdValue}`;
        }
        if (this.filterName && this.filterValue) {
          queryParams += `&${this.filterName}=${this.filterValue}`;
        }
        this.items = await getReferencies(this.resource, queryParams);
        this.loading = false;
      }, 500);
    },
    parentId(newId, oldId) {
      if (!this.watchOnParent) {
        return;
      }
      if (oldId && newId !== oldId) {
        this.inputValue = null;
        this.items = [];
      }
    },
  },
  async created() {
    if (this.value && !this.withInitialValue) {
      this.setSelectedElement(this.value);
    }
    this.regExp = this.outerRegExp ? this.outerRegExp : "";
    if (this.value && this.withInitialValue) {
      await this.fetchAll();
      this.inputValue = this.items.find(i => i.text === "ШТ") || null;
      this.$emit("input", {
        id: this.inputValue.value,
        title: this.inputValue.text,
      });
    }
  },
  mounted() {
    this.$watch(
      () => {
        return this.$children[0].$data.isMenuActive;
      },
      newVal => {
        if (newVal) {
          this.fetchAll();
        }
      },
    );
  },
  methods: {
    handleItemChange() {
      if (!this.search) {
        return;
      }
      if (this.search === this.value?.title) {
        return;
      }
      if (this.search && this.search !== this.inputValue?.text) {
        const item = this.items.find(
          i => i.text.toLowerCase().trim() === this.search.trim(),
        );
        if (item) {
          this.inputValue = item;
        } else {
          this.addNewElement();
        }
      }
      this.$emit(
        "input",
        this.inputValue
          ? {
            id: this.inputValue.value,
            title: this.inputValue.text,
          }
          : null,
      );
    },
    async fetchAll() {
      this.loading = true;

      let queryParams = "";
      if (this.parentFilter && this.parentIdValue) {
        queryParams = `${this.parentFilter}=${this.parentIdValue}`;
      }
      if (this.filterName && this.filterValue) {
        queryParams += `&${this.filterName}=${this.filterValue}`;
      }
      this.items = await getReferencies(this.resource, queryParams);

      if (this.inputValue) {
        const selected = this.items.find(
          i => i.value === this.inputValue.value,
        );
        if (!selected) {
          this.items.push({
            value: this.inputValue.value,
            text: this.inputValue.text,
          });
        }
      }

      if (this.newItem) {
        this.items.push(this.newItem);
      }

      this.loading = false;
    },
    clear() {
      this.items = [];
      this.newItem = null;
      this.inputValue = null;
      this.$emit("input", this.inputValue);
    },
    addNewElement() {
      this.newItem = {
        value: -1,
        text: this.search,
      };
      this.items.push(this.newItem);
      this.inputValue = this.newItem;
    },
    setSelectedElement(value) {
      const newItem = {
        text: value.title,
        value: value.id,
        isRemoved: value.isRemoved,
      };
      this.items.push(newItem);
      this.inputValue = newItem;
    },
  },
};
</script>
<style>
.append-add-icon .v-input__icon--append .v-icon {
  -webkit-transform: none !important;
  transform: none !important;
}
.append-add-icon
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-input__append-inner
  .v-input__icon
  .v-icon {
  color: grey !important;
}
.append-add-icon
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-input__append-inner
  .v-input__icon
  .v-icon:hover {
  color: #424242 !important;
}
</style>
